module.exports = __webpack_public_path__ + "static/media/port-calc.976227b5.png";